import React from 'react';

// Empty-state mark for Deal Flow: an inbox/tray inside the gradient-bordered
// tile. The frame is part of the artwork (the outer <rect>), so this is passed
// to <NoDataV2 framed={false} />.
//
// Gradient ids are per-instance (useId) - a hard-coded id would collide if the
// icon rendered more than once on a page.
const GRADIENT_STOPS = (
  <>
    <stop stopColor="#7852F8" />
    <stop offset="1" stopColor="#84AEF6" />
  </>
);

const NoStartupsIcon = ({ size = 80 }) => {
  const uid = React.useId();
  const g = (n) => `no_startups_${uid}_${n}`;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      {/* Figma: 120x120, radius 26, 1px gradient border. The 0.5 inset keeps the
          1px stroke inside the viewBox, so the radius is 26 - 0.5. */}
      <rect
        x="0.5"
        y="0.5"
        width="119"
        height="119"
        rx="25.5"
        stroke={`url(#${g(0)})`}
      />
      <path
        d="M46.9 46.22 40 60v12a4 4 0 0 0 4 4h32a4 4 0 0 0 4-4V60l-6.9-13.78A4 4 0 0 0 69.52 44H50.48a4 4 0 0 0-3.58 2.22z"
        stroke={`url(#${g(1)})`}
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M80 60H68L64 66H56L52 60H40"
        stroke={`url(#${g(2)})`}
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <linearGradient
          id={g(0)}
          x1="60"
          y1="0"
          x2="60"
          y2="120"
          gradientUnits="userSpaceOnUse"
        >
          {GRADIENT_STOPS}
        </linearGradient>
        <linearGradient
          id={g(1)}
          x1="40"
          y1="44"
          x2="80"
          y2="76"
          gradientUnits="userSpaceOnUse"
        >
          {GRADIENT_STOPS}
        </linearGradient>
        <linearGradient
          id={g(2)}
          x1="40"
          y1="56"
          x2="80"
          y2="70"
          gradientUnits="userSpaceOnUse"
        >
          {GRADIENT_STOPS}
        </linearGradient>
      </defs>
    </svg>
  );
};

export default NoStartupsIcon;
